import { ApolloError, useQuery } from '@apollo/client'
import { FeatureToggleQuery, FeatureToggleQueryVariables } from '../../types'
import { FeatureNameEnum } from './FeatureNameEnum'
import { FEATURE_TOGGLES } from './useFeatureToggle'

export default (
  featureName: FeatureNameEnum,
): { isFeatureEnabled: boolean | undefined; error: ApolloError | undefined; loading: boolean } => {
  const { data, error, loading } = useQuery<FeatureToggleQuery, FeatureToggleQueryVariables>(FEATURE_TOGGLES)

  const isFeatureEnabled =
    data && data.featureToggles && !!data.featureToggles.find((feature) => feature.name === featureName && feature.enabled)

  return { isFeatureEnabled, error, loading }
}
